/* Mag Shaker add-on sections: small shared script (no jQuery). Loaded with "defer" by each ms- section, so it
   never blocks the page from showing. Safe to load more than once (it only runs once). Also re-runs its setup when
   you add or change a section in the theme editor. */
(() => {
  if (window.msSections) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const timers = new WeakMap();

  function carousels(root) {
    root.querySelectorAll('[data-ms-carousel]').forEach((c) => {
      if (c.dataset.msReady) return;
      c.dataset.msReady = '1';
      const tr = c.querySelector('.ms-carousel__track');
      if (!tr) return;
      const dots = [...c.querySelectorAll('.ms-carousel__dots button')];
      const n = tr.children.length;
      const idx = () => Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
      const go = (i) => tr.scrollTo({ left: ((i + n) % n) * tr.clientWidth });
      dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
      c.querySelectorAll('[data-dir]').forEach((b) => b.addEventListener('click', () => go(idx() + +b.dataset.dir)));
      tr.addEventListener('scroll', () => dots.forEach((d, i) => d.setAttribute('aria-current', i === idx())), { passive: true });
      let paused = false;
      ['pointerenter', 'touchstart', 'focusin'].forEach((e) => c.addEventListener(e, () => (paused = true), { passive: true }));
      ['pointerleave', 'touchend', 'focusout'].forEach((e) =>
        c.addEventListener(e, () => setTimeout(() => (paused = false), 2500), { passive: true }));
      const ms = +c.dataset.autoplay;
      if (ms && n > 1 && !reduce) {
        timers.set(c, setInterval(() => { if (!paused && !document.hidden) go(idx() + 1); }, ms));
      }
    });
  }

  function flips(root) {
    root.querySelectorAll('[data-ms-flip]').forEach((f) => {
      if (f.dataset.msReady || reduce) return;
      f.dataset.msReady = '1';
      setInterval(() => { if (!document.hidden) f.classList.toggle('is-flipped'); }, +f.dataset.msFlip || 4000);
    });
  }

  function trust(root) {
    root.querySelectorAll('.ms-trust__row').forEach((r) => {
      if (r.dataset.msReady) return;
      r.dataset.msReady = '1';
      const upd = () => {
        r.classList.toggle('at-start', r.scrollLeft < 4);
        r.classList.toggle('at-end', r.scrollLeft + r.clientWidth > r.scrollWidth - 4);
      };
      r.addEventListener('scroll', upd, { passive: true });
      addEventListener('resize', upd, { passive: true });
      upd();
      // one-time nudge on phones: slide ~1 cm toward the 3rd badge and snap back (once per visit)
      if (r.dataset.nudge !== 'true' || reduce || !matchMedia('(max-width: 960px)').matches) return;
      if (!('IntersectionObserver' in window) || r.scrollWidth <= r.clientWidth + 4) return;
      try { if (sessionStorage.getItem('ms-nudged')) return; } catch (e) {}
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        setTimeout(() => {
          if (r.scrollLeft > 4) return;
          r.classList.add('nudge');
          r.addEventListener('animationend', () => r.classList.remove('nudge'), { once: true });
          try { sessionStorage.setItem('ms-nudged', '1'); } catch (e) {}
        }, 700);
      }, { threshold: 0.9 });
      io.observe(r);
    });
  }

  // "Set quantity to 3" (3-pack block inside Dawn's product form)
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ms-qty]');
    if (!b) return;
    const scope = b.closest('section, .shopify-section, product-info') || document;
    const q = scope.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    if (!q) return;
    q.value = b.dataset.msQty;
    q.dispatchEvent(new Event('change', { bubbles: true }));
    q.focus();
  });

  // Sticky add-to-cart: appears once Dawn's own Add to cart button has scrolled off the top of the screen.
  // Its button presses Dawn's real Add to cart, so the selected color, the quantity, the cart drawer and every app
  // work exactly as they do now.
  function sticky(root) {
  if (!document.getElementById('ms-sticky-color-style')) {
    const style = document.createElement('style');
    style.id = 'ms-sticky-color-style';
    style.textContent = `
      .ms-sticky__color {
        position: relative;
        flex: 0 0 auto;
      }
      .ms-sticky__color summary {
        display: flex;
        align-items: center;
        gap: 7px;
        padding: 8px;
        cursor: pointer;
        list-style: none;
      }
      .ms-sticky__color summary::-webkit-details-marker {
        display: none;
      }
      .ms-sticky__color-dot {
        display: inline-block;
        width: 28px;
        height: 28px;
        flex: 0 0 28px;
        border: 1px solid #777;
        border-radius: 50%;
        overflow: hidden;
        background: #eee;
      }
      .ms-sticky__color-dot .swatch {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: var(--swatch--background, transparent);
  background-position: var(--swatch-focal-point, center);
  background-size: cover;
  background-repeat: no-repeat;
}

      .ms-sticky__color-menu {
        position: absolute;
        bottom: calc(100% + 12px);
        left: 0;
        width: 210px;
        max-width: 80vw;
        max-height: 50vh;
        overflow-y: auto;
        padding: 6px;
        border: 1px solid #ddd;
        border-radius: 10px;
        background: #fff;
        color: #111;
        box-shadow: 0 4px 20px #0002;
      }
      .ms-sticky__color-choice {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        min-height: 44px;
        padding: 8px;
        border: 0;
        border-radius: 6px;
        background: transparent;
        color: inherit;
        text-align: left;
        cursor: pointer;
        font: inherit;
      }
      .ms-sticky__color-choice[aria-pressed="true"] {
        background: #eee;
      }
      .ms-sticky__color-choice:disabled {
        opacity: .45;
        cursor: not-allowed;
      }
        .ms-sticky__color summary > span:last-child {
  font-size: 2em;
  line-height: 1;
}

.ms-sticky__color-choice:disabled .ms-sticky__color-dot {
  position: relative;
}

.ms-sticky__color-choice:disabled .ms-sticky__color-dot::after {
  content: "";
  position: absolute;
  top: 50%;
  left: -15%;
  width: 130%;
  height: 2px;
  background: #d71920;
  transform: rotate(-45deg);
}

.ms-sticky__color-choice:disabled > span:last-child {
  text-decoration: line-through;
}

    `;
    document.head.append(style);
  }

  root.querySelectorAll('[data-ms-sticky]').forEach((s) => {
    if (s.dataset.msReady) return;

    const btn = s.querySelector('[data-ms-sticky-add]');
    const wrap = s.querySelector('.ms-wrap');
    if (!btn || !wrap) return;

    // Match the sticky section's product to an actual product form.
    const findAtc = () => {
      const buttons = [
        ...document.querySelectorAll(
          '.product-form__submit[name="add"]'
        )
      ];

      return buttons.find((button) => {
        const scope = button.closest('product-info, .shopify-section');
        const picker = scope?.querySelector('variant-selects');
        const data = picker?.querySelector('[data-selected-variant]');

        try {
          const variant = JSON.parse(data?.textContent || 'null');
          return variant?.id != null && Boolean(
  scope?.querySelector(
    `form[action*="/cart/add"] input[name="id"][value="${variant.id}"]`
  )
);

        } catch (error) {
          return false;
        }
      });
    };

    let atc = findAtc();
    if (!atc) return;

    s.dataset.msReady = '1';

    const label = btn.querySelector('span');
    const scope = atc.closest('product-info, .shopify-section');
    let pendingColor = null;

    const picker = () => scope.querySelector('variant-selects');

    const colorField = () => {
      return [...(picker()?.querySelectorAll('fieldset') || [])]
        .find((field) => {
          const legend = field.querySelector('legend');
          return /^\s*colou?r\s*:/i.test(legend?.textContent || '') ||
            /^\s*colou?r\s*$/i.test(legend?.textContent || '');
        });
    };

    const inputs = () => [
      ...(colorField()?.querySelectorAll('input[type="radio"]') || [])
    ];

    // Copy only the visual swatch, never its radio input or label IDs.
    const makeDot = (input) => {
  const dot = document.createElement('span');
  dot.className = 'ms-sticky__color-dot';
  dot.setAttribute('aria-hidden', 'true');

  // Shop: use the matching visible Globo color swatch.
  const globoItem = [
    ...scope.querySelectorAll(
      '.globo-swatch-product-detail li[data-value]'
    )
  ].find((item) =>
    item.dataset.value === input.value &&
    item.closest('ul')?.classList.contains('g-variant-color-detail')
  );

  const globoLabel = globoItem?.querySelector('label');

  if (globoLabel) {
    const appearance = getComputedStyle(globoLabel);

    dot.style.backgroundColor = appearance.backgroundColor;
    dot.style.backgroundImage = appearance.backgroundImage;
    dot.style.backgroundPosition = appearance.backgroundPosition;
    dot.style.backgroundSize = 'cover';
    dot.style.backgroundRepeat = 'no-repeat';

    return dot;
  }

  // Home: retain the original native swatch.
  const source = input.labels?.[0]?.querySelector('.swatch');

  if (source) {
    const clone = source.cloneNode(true);
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach((el) =>
      el.removeAttribute('id')
    );
    dot.append(clone);
  }

  return dot;
};


    const details = document.createElement('details');
    details.className = 'ms-sticky__color';

    const summary = document.createElement('summary');
    summary.setAttribute('aria-label', 'Choose color');

    const menu = document.createElement('div');
    menu.className = 'ms-sticky__color-menu';

    details.append(summary, menu);
    wrap.insertBefore(details, wrap.firstChild);

    const selectedData = () => {
      try {
        return JSON.parse(
          picker()?.querySelector('[data-selected-variant]')?.textContent ||
          'null'
        );
      } catch (error) {
        return null;
      }
    };

    const sync = () => {
      atc = findAtc() || atc;

      const radios = inputs();
      const selected = radios.find((input) => input.checked);

      details.hidden = !selected;

      if (selected) {
        summary.replaceChildren(makeDot(selected));

        const arrow = document.createElement('span');
        arrow.textContent = '▾';
        arrow.setAttribute('aria-hidden', 'true');
        summary.append(arrow);
        summary.setAttribute(
          'aria-label',
          `Color: ${selected.value}. Choose color`
        );

        // Wait until the main picker's returned variant reflects the choice.
        if (pendingColor !== null) {
          const fields = [
            ...(picker()?.querySelectorAll(
              'fieldset, .product-form__input--dropdown'
            ) || [])
          ];
          const position = fields.indexOf(colorField());
          const variant = selectedData();

          if (position >= 0 &&
              variant?.options?.[position] === pendingColor) {
            pendingColor = null;
          }
        }
      }

      btn.disabled = atc.disabled || pendingColor !== null;
      btn.setAttribute('aria-busy', String(pendingColor !== null));

      const text = pendingColor !== null
        ? 'Updating…'
        : atc.disabled
          ? (s.dataset.soldout || 'Sold out')
          : (s.dataset.label || 'Add to cart');

      if (label && label.textContent !== text) {
        label.textContent = text;
      }
    };

    const buildMenu = () => {
      menu.replaceChildren();

      inputs().forEach((input) => {
        const choice = document.createElement('button');
        choice.type = 'button';
        choice.className = 'ms-sticky__color-choice';
        choice.setAttribute('aria-pressed', String(input.checked));

        const unavailable =
  input.disabled ||
  input.classList.contains('disabled') ||
  input.classList.contains('visually-disabled');


        choice.disabled = unavailable;

        const name = document.createElement('span');
        name.textContent =
          input.value + (unavailable ? ' — Unavailable' : '');

        choice.append(makeDot(input), name);

        choice.addEventListener('click', () => {
          // Re-find the live input: Dawn can replace the picker.
          const current = inputs().find((item) =>
            item.value === input.value
          );
          if (!current || current.disabled) return;

          details.open = false;
          summary.focus();

          const globoItem = [
  ...scope.querySelectorAll(
    '.globo-swatch-product-detail li[data-value]'
  )
].find((item) =>
  item.dataset.value === current.value &&
  item.closest('ul')?.classList.contains('g-variant-color-detail')
);

const globoLabel = globoItem?.querySelector('label');

const globoRadio = globoItem?.querySelector('input[type="radio"]');

if (globoRadio) {
  // Activate Globo without the label's default focus transfer.
  globoRadio.click();
  summary.focus({ preventScroll: true });
  sync();
  return;
}


// Keep the native-picker behavior where Globo isn't present.
if (current.checked) return;

pendingColor = current.value;
btn.disabled = true;

current.checked = true;
current.dispatchEvent(new Event('change', { bubbles: true }));
sync();

        });

        menu.append(choice);
      });
    };

    details.addEventListener('toggle', () => {
      if (details.open) buildMenu();
    });

    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        details.open = false;
        summary.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!details.contains(event.target)) details.open = false;
    });

    const io = new IntersectionObserver(([entry]) => {
      const visible =
        !entry.isIntersecting && entry.boundingClientRect.bottom < 0;

      s.classList.toggle('show', visible);
      if (!visible) details.open = false;
    });
    io.observe(atc);

    new MutationObserver(() => {
      const next = findAtc();
      if (next && next !== atc) {
        io.unobserve(atc);
        atc = next;
        io.observe(atc);
      }
      sync();
      if (details.open) buildMenu();
    }).observe(scope, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'checked']
    });

    scope.addEventListener('change', () => {
      sync();
      if (details.open) buildMenu();
    });

    btn.addEventListener('click', () => {
      sync();
      if (btn.disabled) return;
      atc.click();
    });

    sync();
  });
}


  // Hero "fill the screen": measure the announcement bar + menu height above it once (and on resize). The CSS
  // already assumes 126px (your bars), so normally nothing moves.
  function heroTop() {
    const h = document.querySelector('.ms-hero--fill');
    if (!h) return;
    const t = Math.round(h.getBoundingClientRect().top + window.scrollY);
    if (t < 400) document.documentElement.style.setProperty('--ms-hero-top', t + 'px');
  }
  addEventListener('resize', heroTop, { passive: true });

  // FAQ page: live search, open a question from a link (#q-...), highlight the category in view
  function faq(root) {
    root.querySelectorAll('[data-ms-faq]').forEach((f) => {
      if (f.dataset.msReady) return;
      f.dataset.msReady = '1';
      const input = f.querySelector('[data-ms-faq-search]');
      const items = [...f.querySelectorAll('details')];
      const cats = [...f.querySelectorAll('.ms-faqp__cat')];
      const none = f.querySelector('.ms-faqp__none');
      let t;
      const run = () => {
        const q = (input.value || '').trim().toLowerCase();
        f.classList.toggle('is-searching', !!q);
        let shown = 0;
        items.forEach((d) => {
          const hit = !q || d.textContent.toLowerCase().includes(q);
          d.hidden = !hit;
          if (q) d.open = hit;
          if (q && hit) shown++;
        });
        cats.forEach((c) => { c.hidden = [...c.querySelectorAll('details')].every((d) => d.hidden); });
        if (none) none.classList.toggle('is-on', !!q && !shown);
      };
      if (input) input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(run, 120); });
      const openHash = () => {
        if (!location.hash) return;
        let el = null;
        try { el = f.querySelector(location.hash); } catch (e) { return; }
        if (el && el.tagName === 'DETAILS') { el.hidden = false; el.open = true; }
      };
      openHash();
      addEventListener('hashchange', openHash);
      const links = [...f.querySelectorAll('.ms-faqp__nav a')];
      if (links.length && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((es) => es.forEach((e) => {
          if (!e.isIntersecting) return;
          links.forEach((a) => a.classList.toggle('is-on', a.getAttribute('href') === '#' + e.target.id));
        }), { rootMargin: '-40% 0px -55% 0px' });
        cats.forEach((c) => io.observe(c));
      }
    });
  }

  function init(root = document) { heroTop(); carousels(root); flips(root); trust(root); sticky(root); faq(root); }
  window.msSections = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
